module.exports = __webpack_public_path__ + "img/tourism.dd3cd541.svg";